import { workApplicationService as ogpWorkApplicationService } from 'ogp/services';
import { workApplicationService as hqWorkApplicationService } from 'hq/services';
import { useMutation, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { SiteDetectionResult } from '../../../../../../hooks';

type WorkApplicationMutationParams = {
  workApplicationId: string;
  workerId: string;
  siteDetectionResult: SiteDetectionResult;
};

export const useAcceptWorkApplication = () => {
  const mutationFn = (params: WorkApplicationMutationParams) => getMutationFunction(params);
  const queryClient = useQueryClient();

  return useMutation(mutationFn, {
    onSuccess: async () => {
      queryClient.invalidateQueries(QUERY_KEYS.projects());
    },
  });
};

const getMutationFunction = (params: WorkApplicationMutationParams) => {
  const { siteDetectionResult, workApplicationId, workerId } = params;
  if (siteDetectionResult.isHQ) {
    return hqWorkApplicationService.acceptWorkApplication(workApplicationId, workerId);
  }
  if (siteDetectionResult.isOGP) {
    return ogpWorkApplicationService.acceptWorkApplication(workApplicationId, workerId);
  }

  throw new Error(
    `useAcceptWorkApplication: site "${siteDetectionResult.site}" is neither HQ nor OGP.`
  );
};
